// extracted by mini-css-extract-plugin
export default {"container":"style_container__dIM52","menu__item":"style_menu__item__kDddo"};